<template>
    <div>
        <h3 class="is-size-2">{{ title }}</h3>
        <p>Prosimo izberite drug album, lokacijo, ali se vrnite na prejšnjo stran s klikom na spodnjo povezavo</p>
        <div class="mb-40">
            <a class="link" @click="goBack">
                <span class="icon">
                    <i class="fa fa-arrow-left"></i>
                </span>
                Nazaj
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name:'app-backbuttton',
    props: ['title'],
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/BackButton.vue